import { useSelector } from "react-redux"

const MobileSideBar = () => {
  const theme = useSelector((state) => state.nav.theme)
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.37508 3.95834H3.95841C3.03794 3.95834 2.29175 4.70453 2.29175 5.625V14.375C2.29175 15.2955 3.03794 16.0417 3.95841 16.0417H9.37508M9.37508 3.95834H16.0417C16.9622 3.95834 17.7084 4.70453 17.7084 5.625V14.375C17.7084 15.2955 16.9622 16.0417 16.0417 16.0417H9.37508M9.37508 3.95834V16.0417"
        stroke={theme === "light" ? "#434C69" : "rgba(255, 255, 255, .36)"}
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 7.08366C6.49982 7.4517 6.20109 7.74967 5.83301 7.74967C5.46508 7.7495 5.16717 7.45159 5.16699 7.08366C5.16699 6.71557 5.46497 6.41684 5.83301 6.41666C6.2012 6.41666 6.5 6.71547 6.5 7.08366ZM6.5 9.99967C6.5 10.3679 6.2012 10.6667 5.83301 10.6667C5.46497 10.6665 5.16699 10.3678 5.16699 9.99967C5.16717 9.63174 5.46508 9.33383 5.83301 9.33366C6.20109 9.33366 6.49982 9.63163 6.5 9.99967ZM6.5 12.9167C6.5 13.2849 6.2012 13.5837 5.83301 13.5837C5.46497 13.5835 5.16699 13.2847 5.16699 12.9167C5.16699 12.5486 5.46497 12.2498 5.83301 12.2497C6.2012 12.2497 6.5 12.5485 6.5 12.9167Z"
        fill={theme === "light" ? "#434C69" : "rgba(255, 255, 255, .36)"}
        stroke={theme === "light" ? "#434C69" : "rgba(255, 255, 255, .36)"}
        strokeWidth="0.5"
      />
    </svg>
  )
}

export default MobileSideBar
